import { Link } from "react-router-dom";
// import logo from "../../logo.jpg"; 
import logo from '../../assets/logo.jpg';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRightFromBracket } from "@fortawesome/free-solid-svg-icons";
import useAdminUserStore from "../../store/adminUserStore";
import SessionTimer from "../SessionTimer/SessionTimer";

// Interfaces
interface SidebarProps {
  links: Array<{ path: string; label: string }>; 
}

function Sidebar({ links }: SidebarProps) {
const {logout} = useAdminUserStore();

  //Actions
  const handleAdminLogout = () => {
    logout();
  }
  return (
    <aside className="sidemenu">
      <div className="admin-top-side">
      <SessionTimer />
      <div className='admin-return' onClick={handleAdminLogout}><FontAwesomeIcon  icon={faArrowRightFromBracket} /></div>
      </div>
  
    <nav>
      <ul>
        {links.map((link,index) =>
          link.path === "/config" ? (
            // If path is "/config", show the logo
            <li className="logoli" key={link.path}>
              <div className="logo">
                <Link to="/">
                  <img src={logo} alt="Home Logo" />
                </Link>
              </div>
            </li>
          ) : (
            <li className={`menuli ${index === 1 ? "first-menuli" : ""}`}
             key={link.path}>
              <Link to={link.path}>{link.label}</Link>
            </li>
          )
        )}
      </ul>
    </nav>
  </aside>
  );
}

export default Sidebar;
